<template>
  <div class="tabs" @keydown="onKeydown" ref="tabs">
    <ul>
      <router-link v-for="(tab, index) in tabList" :key="index"
        :to="tab.route"
        tag="li"
        replace
        ref="tab"
        :class="{ hovered: hoverIdx === index, 'forced-active': tab.forceActive }"
        :aria-selected="selectedIndex === index"
      >
        <a
          :tabindex="selectedIndex === index ? 0 : -1"
          :aria-label="tab.ariaLabel || tab.label"
          @blur="onBlur()"
          @focus="hoverIdx = index"
        >
          {{ tab.label }}
        </a>
      </router-link>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    tabs: Array,
  },
  data() {
    return {
      hoverIdx: -1,
      selectedIndex: -1,
    };
  },
  mounted() {
    this.selectedIndex = this.tabs.findIndex(tab => this.matchValue(this.$route, tab));
    this.hoverIdx = this.selectedIndex;
  },
  computed: {
    tabList() {
      return this.tabs.map(tab => ({
        ...tab,
        route: {
          ...(tab.name && { name: tab.name }),
          ...(tab.query && { query: { ...tab.query } }),
          ...(tab.path && { path: tab.path }),
        },
      }));
    },
  },
  watch: {
    $route(to) {
      this.selectedIndex = this.tabs.findIndex(tab => this.matchValue(to, tab));
      this.hoverIdx = this.selectedIndex;
    },
  },
  methods: {
    handleClickOutside(event) {
      if (this.$refs.tabs && !this.$refs.tabs.contains(event.target)) {
        this.selectedIndex = -1;
        this.hoverIdx = -1;
      }
    },
    focusOption(index = null) {
      const resolvedIndex = index === null
        ? this.tabs.findIndex(tab => this.matchValue(this.$route, tab))
        : index;
      if (resolvedIndex < 0 || !this.$refs.tab || !this.$refs.tab[resolvedIndex]) {
        return;
      }
      this.selectedIndex = resolvedIndex;
      this.hoverIdx = resolvedIndex;
      this.$refs.tab[resolvedIndex].$el.children[0].focus();
    },
    onKeydown(evt) {
      const total = this.tabs.length;

      if (evt.key === 'ArrowRight') {
        evt.preventDefault();
        this.hoverIdx = (this.hoverIdx + 1) % total;
      }

      if (evt.key === 'ArrowLeft') {
        evt.preventDefault();
        this.hoverIdx = (this.hoverIdx - 1 + total) % total;
      }

      if (evt.key === 'Enter' || evt.key === ' ') {
        evt.preventDefault();
        if (this.hoverIdx === this.selectedIndex) return;
        this.focusOption(this.hoverIdx);
        const { route } = this.tabList[this.hoverIdx];
        this.$router.push({ ...route });
      }
    },
    matchValue(to, tab) {
      if (tab.name) {
        return to.name === tab.name;
      }
      if (tab.path) {
        const lastSegment = to.path.split('/').pop();
        return lastSegment === tab.path;
      }
      return false;
    },
    onBlur() {
      this.hoverIdx = -1;
    },
  },
};
</script>
<style lang="sass" scoped>
  li:focus-visible
    outline: none
  .tabs ul li.hovered
    text-shadow: #444444 0px 0px 0.65px, #444444 0px 0px 0.65px
    a
      color: #444444
      border-bottom-color: #444444
  .tabs li.forced-active
    text-shadow: #444444 0px 0px 0.65px, #444444 0px 0px 0.65px;
  .forced-active a
    border-bottom-color: #444 !important;
    color: #444;
</style>
